import { useDispatch } from 'react-redux';

import ListMenu from "../Commons/ListMenu";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';
import useLog from '../../hooks/useLog';

import { getLabel } from "../../tools/Dictionary";

import "./Home.css";

const HomePage = (props) =>
{
  //Logs
  const { logPageView } = useLog();

  //Props
  //const IsDesktop = props.isDesktop;

  //Redux
  const Dispatch = useDispatch();

  //Variables
  const component = "HomePage";

  useMount(() => {
    logPageView("Home");
    Dispatch(setCurrentNavigation("Home"));
  }, []);

  return (
    <div>
      <div className="home_text">
        {getLabel(component, "Welcome to the Innovair Solutions application...")}
      </div>
      <div className="home_menu_cont">
        <ListMenu />
      </div>
    </div>
  )

};

export default HomePage;